import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { ChevronLeft } from 'lucide-react';
import { NavbarPhoneTitleProps } from './types';

export const NavbarPhoneTitle = ({ data: { tab, backTo } }: NavbarPhoneTitleProps) => {
  const { t } = useTranslation('app');

  return (
    <div className="flex min-w-0 items-center">
      {backTo && (
        <Link
          to={backTo}
          aria-label={t('actions.back')}
          className="-ml-2.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-neutral-800 active:bg-neutral-50">
          <ChevronLeft className="h-6 w-6" />
        </Link>
      )}
      <h1 className="truncate text-lg font-bold text-neutral-900">{t(`navigation.${tab}`)}</h1>
    </div>
  );
};
